import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUpRightFromSquare } from '@fortawesome/free-solid-svg-icons';

import minnect from '../../assets/minnect_logo.webp';
import profilePic from '../../assets/minnect_profile_pic.jpeg';

// Off until Minnect payments are sorted out. Everything on the site that links
// to Minnect renders through this module, so this one flag shows or hides all
// of it: the Coming Soon card below and the Services pages' ad-hoc callout.
export const MINNECT_ENABLED = false;

const MINNECT_URL = 'https://app.minnect.com/expert/DerekDrummond';


// A one-off call for engineering advice, offered on the Services pages beside
// the fixed engagements for anyone whose question is smaller than either.
export const AdHocAdvice = ({ className }) => {
  if (!MINNECT_ENABLED) {
    return null;
  }

  return (
    <aside className={`${className || ''} flex flex-col gap-4 rounded-lg border border-neutral-800 bg-neutral-900 p-6 sm:flex-row sm:items-center sm:justify-between`}>
      <div className='flex items-center gap-4'>
        <img src={minnect} alt='' className='h-8 w-8 flex-shrink-0' />
        <div>
          <h3 className='font-heading text-2xl text-neutral-50'>Just need ad-hoc engineering advice?</h3>
          <p className='mt-1 font-body text-sm text-neutral-400'>Book a one-off call on Minnect for a second opinion on a single decision.</p>
        </div>
      </div>
      <a
        href={MINNECT_URL}
        target='_blank'
        rel='noreferrer'
        className='inline-flex h-11 flex-shrink-0 items-center justify-center gap-2.5 rounded-lg border border-neutral-700 px-6 font-body text-[15px] tracking-wide text-primary-light transition-colors duration-150 hover:border-neutral-500 hover:text-primary-foreground'
      >
        Book on Minnect
        <FontAwesomeIcon icon={faArrowUpRightFromSquare} size='sm' className='opacity-80' />
      </a>
    </aside>
  );
};


const Minnect = () => {
  if (!MINNECT_ENABLED) {
    return null;
  }

  return (
    <div className='rounded-lg border border-neutral-800 bg-neutral-900 p-6 shadow-sm'>
      <div className='flex items-center gap-2 mb-6'>
        <h2 className='font-heading text-2xl text-neutral-50'>Need a Minute to Connect? You can find me on Minnect</h2>
        <img src={minnect} alt='Minnect Logo' className='h-6 w-6 inline-block'/>
      </div>
      <div className='flex flex-col sm:flex-row gap-6 mb-6'>
        <img src={profilePic} alt='Minnect Profile Pic' className='rounded-lg h-48 w-48 object-cover flex-shrink-0'/>
        <div className='font-body text-sm text-neutral-300 leading-relaxed space-y-3'>
          <p><span className='text-neutral-50 font-body'>Bio: </span>My mission is to help founders build great companies, with best in class products, and exceptional engineering teams.</p>
          <p>I've been an engineering leader at companies that exited for $1.4 Billion, raised a $50 million dollar Series-A and a $14 million dollar Series-B. I've seen what they did right and where they went wrong. I can help you avoid the mistakes while building a product that provides superior customer experience.</p>
          <p>I have 12+ years of industry experience leading engineering teams to build mobile & web applications, in the cyber-security, fintech, and insurance-tech spaces. If you need a ground up solution, advice on where to start or someone to refactor v1 of your product to a scalabe solution I can help!</p>
        </div>
      </div>
      <div className='text-center'>
        <a href={MINNECT_URL}
          className='inline-flex items-center justify-center rounded-lg px-8 py-2.5 bg-primary text-sm font-body text-white shadow-sm transition-colors duration-150 hover:bg-primary-light focus:outline-none focus:ring-2 focus:ring-primary-light focus:ring-offset-2 focus:ring-offset-neutral-950'>
          Connect with me on Minnect
        </a>
      </div>
    </div>
  );
};

export default Minnect;
